import * as React from "react";
import { BalanceUpdateVirtualItemGiftInChatDetailsFragmentFragment } from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";
import { Trans } from "react-i18next";

export const BalanceUpdateVirtualItemGiftInChatDetails = ({
  details,
}: {
  details: BalanceUpdateVirtualItemGiftInChatDetailsFragmentFragment;
}) => {
  return (
    <Trans i18nKey="transaction.BalanceUpdateVirtualItemGiftDetails_details">
      Send virtual gift <strong>{{ name: details.name }}</strong>
    </Trans>
  );
};
